import { render } from "./UseHTMLString.vue?vue&type=template&id=2b43a4d5"
import script from "./UseHTMLString.vue?vue&type=script&lang=js"
export * from "./UseHTMLString.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__